export default __webpack_public_path__ + "static/media/snake.e1041e8b.png";